module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/subtract-79651729457411f40bc18f60746940f6.svg";